import React, { useState, useEffect } from "react";
import { apiGet, apiPost } from "../utils/api";
import { useNavigate } from "react-router-dom";
import Layout from "./Layout";

function Onboarding() {
  const [defaults, setDefaults] = useState({ categories: [], currencies: [] });
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [selectedCurrencies, setSelectedCurrencies] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    // Fetch default categories and currencies
    apiGet("/onboarding/defaults")
      .then((res) => res.json())
      .then((data) => {
        setDefaults(data);
        // Pre-select some common defaults
        setSelectedCategories(["Bargeld", "Sparkonto", "ETF"]);
        setSelectedCurrencies(["CHF"]);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error loading defaults:", err);
        setLoading(false);
      });
  }, []);

  const toggleCategory = (catName) => {
    setSelectedCategories((prev) =>
      prev.includes(catName)
        ? prev.filter((c) => c !== catName)
        : [...prev, catName]
    );
  };

  const toggleCurrency = (currCode) => {
    setSelectedCurrencies((prev) =>
      prev.includes(currCode)
        ? prev.filter((c) => c !== currCode)
        : [...prev, currCode]
    );
  };

  const handleSetup = () => {
    if (selectedCategories.length === 0) {
      alert("Bitte wählen Sie mindestens eine Kategorie aus.");
      return;
    }
    if (selectedCurrencies.length === 0) {
      alert("Bitte wählen Sie mindestens eine Währung aus.");
      return;
    }

    setSaving(true);
    apiPost("/onboarding/setup", {
      categories: selectedCategories,
      currencies: selectedCurrencies,
    })
      .then((res) => res.json())
      .then((data) => {
        console.log("Setup complete:", data);
        // Redirect to input page to start adding data
        navigate("/input");
      })
      .catch((err) => {
        console.error("Setup error:", err);
        alert("Fehler beim Setup. Bitte versuchen Sie es erneut.");
        setSaving(false);
      });
  };

  if (loading) {
    return (
      <Layout title="Willkommen!">
        <div className="card">
          <p>Lade Optionen...</p>
        </div>
      </Layout>
    );
  }

  return (
    <Layout title="Willkommen! 👋">
      <div className="card" style={{ maxWidth: "600px", margin: "0 auto" }}>
        <div style={{ textAlign: "center", marginBottom: "var(--space-x-large)" }}>
          <h2 style={{ fontSize: "1.5rem", marginBottom: "var(--space-small)" }}>
            Was möchten Sie tracken?
          </h2>
          <p style={{ color: "var(--text-secondary)", fontSize: "var(--font-size-medium)" }}>
            Aktivieren Sie die Asset-Typen, die Sie verwenden
          </p>
        </div>

        {/* Categories Section */}
        <div style={{ marginBottom: "var(--space-x-large)" }}>
          <h3 style={{
            fontSize: "0.75rem",
            textTransform: "uppercase",
            letterSpacing: "0.05em",
            color: "var(--text-secondary)",
            marginBottom: "var(--space-medium)",
            fontWeight: "600"
          }}>
            Asset-Kategorien
          </h3>

          <div className="toggle-list">
            {defaults.categories.map((cat) => (
              <div
                key={cat.name}
                className="toggle-item"
                onClick={() => toggleCategory(cat.name)}
              >
                <div className="toggle-item-content">
                  <div className="toggle-item-title">{cat.name}</div>
                  <div className="toggle-item-description">{cat.description}</div>
                </div>
                <label className="toggle-switch" onClick={(e) => e.stopPropagation()}>
                  <input
                    type="checkbox"
                    checked={selectedCategories.includes(cat.name)}
                    onChange={() => toggleCategory(cat.name)}
                  />
                  <span className="toggle-slider"></span>
                </label>
              </div>
            ))}
          </div>
        </div>

        {/* Currencies Section */}
        <div style={{ marginBottom: "var(--space-x-large)" }}>
          <h3 style={{
            fontSize: "0.75rem",
            textTransform: "uppercase",
            letterSpacing: "0.05em",
            color: "var(--text-secondary)",
            marginBottom: "var(--space-medium)",
            fontWeight: "600"
          }}>
            Währungen
          </h3>

          <div className="toggle-list">
            {defaults.currencies.map((cur) => (
              <div
                key={cur.code}
                className="toggle-item"
                onClick={() => toggleCurrency(cur.code)}
              >
                <div className="toggle-item-content">
                  <div className="toggle-item-title">{cur.code}</div>
                  <div className="toggle-item-description">{cur.description}</div>
                </div>
                <label className="toggle-switch" onClick={(e) => e.stopPropagation()}>
                  <input
                    type="checkbox"
                    checked={selectedCurrencies.includes(cur.code)}
                    onChange={() => toggleCurrency(cur.code)}
                  />
                  <span className="toggle-slider"></span>
                </label>
              </div>
            ))}
          </div>
        </div>

        {/* Action Buttons */}
        <div style={{
          display: "flex",
          flexDirection: "column",
          gap: "var(--space-medium)",
          marginTop: "var(--space-x-large)"
        }}>
          <button
            className="btn btn-primary"
            onClick={handleSetup}
            disabled={saving}
            style={{
              width: "100%",
              padding: "1rem",
              fontSize: "1rem",
              fontWeight: "600"
            }}
          >
            {saving ? "Wird eingerichtet..." : "Fertig"}
          </button>
          <button
            className="btn btn-secondary"
            onClick={() => navigate("/customize")}
            disabled={saving}
            style={{ width: "100%" }}
          >
            Überspringen
          </button>
        </div>
      </div>
    </Layout>
  );
}

export default Onboarding;
